import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getExtractionConfigurationsQueryKey } from "Configurations/Api/Queries/useExtractionConfigurationsQuery";
import { duplicateExtractionConfiguration } from "Infrastructure/Api/Api";

export function useDuplicateExtractionConfigurationMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: number) => duplicateExtractionConfiguration(id),
		onSuccess: () => {
			// Invalidate all extraction configuration queries regardless of pagination
			queryClient.invalidateQueries({
				predicate: (query) =>
					Array.isArray(query.queryKey) &&
					query.queryKey[0] === "EXTRACTION_CONFIGURATIONS_QUERY",
			});
		},
	});
}
